// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"1f5f9d55","233":"ac72fae5","288":"24dcd14d","327":"61a7a6a3","401":"b2f29eec","641":"013da95a","673":"99d1d56c","852":"04cacbee","874":"9ce3bd58"}[chunkId] + ".chunk.js";
};